import config from "./config";
var axios = config();
import * as _ from "lodash";

export default {
  getAllProposals(filters, page, pageSize, sortBy, sortDesc) {
    var filter = "";
    if (filters.search) {
      filter += "&search=" + filters.search;
    }
    if (page) {
      filter += "&pageNumber=" + page;
    }
    if (pageSize) {
      filter += "&pageSize=" + pageSize;
    }

    if (sortBy) {
      filter += "&sortBy=" + sortBy + "&sortDesc=" + sortDesc;
    }

    _.forEach(_.keys(filters), key => {
      if (filters[key]) {
        filter += "&" + key + "=" + filters[key];
      }
    });

    return axios.get("/api/proposals?" + filter);
  },

  getProposalById(id) {
    return axios.get("/api/Proposals/" + id);
  },

  getSources() {
    return axios.get("/api/proposals/sources");
  },

  getSponsors() {
    return axios.get("/api/proposals/sponsors");
  },

  getStatuses() {
    return axios.get("/api/proposals/statuses");
  },

  createCommunityPartnerProposals(id, items) {
    return axios.post("/api/proposals/" + id + "/communityPartners", items);
  },

  lastUpdated() {
    return axios.get("/api/proposals/updated");
  },

  getByTag(tagId) {
    return axios.get("/api/Proposals/tag/" + tagId);
  }
};
